import { TranslateKeys } from '@og-shared/types';
const en: { [key in TranslateKeys]: string } = {
  '<': 'Less than',
  '<=': 'Less than or equal',
  '==': 'Equals',
  '>': 'Greater than',
  '>=': 'Greater than or equal',
  ACCEPTED_INVITES: 'Accepted Invites',
  ACCOMPLISH_GOAL_ON: "You'll accomplish this goal on:",
  ACCOUNT_BALANCE_IS:
    '*Account balance is an estimate based on the information you have provided, and assumes that your savings goals will stay in your account.',
  ACCOUNT_BALANCE_WILL_CHANGE: 'Your account balance will change by %{amount}',
  ACCOUNT_BUDGETS: 'Spending categories projected for this account',
  ACCOUNT_FROM: 'From Account',
  ACCOUNT_S: 'Account |||| Accounts',
  ACCOUNT_STATE_BUDGET: 'Included in spending plan',
  ACCOUNT_STATE_BUDGET_DESC:
    "We'll sync transactions and the account balance to %{budgetName}",
  ACCOUNT_STATE_EXCLUDE: "Don't sync to %{budgetName}",
  ACCOUNT_STATE_EXCLUDE_DESC:
    "We won't sync this account to %{budgetName}. We'll remove this account and any of it's past transactions",
  ACCOUNT_STATE_TRACK: 'Tracked Account |||| Tracked Accounts',
  ACCOUNT_STATE_TRACK_DESC:
    "You'll be able to see account balance as part of your net worth in %{budgetName} but transactions won't show as part of your spending plan",
  ACCOUNT_S_IN: 'Account in One Goal |||| Accounts in One Goal',
  ACCOUNT_TO: 'To Account',
  ACCOUNT_TO_DESC:
    'Select the credit card account that this bill will pay off in full. We use this to project your account balance over time.',
  ACCOUNTS_CASH_FLOW: 'Accounts Cash Flow',
  ACCOUNTS_NOT_INCLUDED: 'Accounts not included in spending plan',
  ACCOUNT_WILL_DELETE: 'Account will be deleted',
  ACTIONS: 'Actions',
  ADD: 'Add',
  ADDING_FUTURE_CASH: "Sweet! You're adding %{weeks} of income to your runway.",
  ADD_ACCOUNT: 'Add Account',
  ADD_ANOTHER_BILL: 'Add another bill',
  ADD_ANOTHER_BUDGET: 'Add another spending category',
  ADD_ANOTHER_SAVINGS: 'Add another savings category',
  ADD_BILL: 'Add Bill',
  ADD_BILLS: "Sweet, now let's add your bills",
  ADD_BUDGET: 'Add Category',
  ADD_INCOME: 'Add Income',
  ADD_LINKED_ACCOUNT: 'Add Linked Account',
  ADD_LINKED_ACCOUNT_DESC:
    'Connect to your bank to securely sync your account balances & transactions',
  ADD_MANUAL_ACCOUNT: 'Add Manual Account',
  ADD_MONEY: 'Add %{money}',
  ADD_SAVINGS: 'Add Savings Category',
  ADD_TO_BUDGET: 'Add to Spending Plan',
  ADD_TRANSACTION: 'Add Transaction',
  ADVANCED: 'Advanced',
  AGE_OF_MONEY_DESC:
    "Some refer to this as the age of your money. It means that if you stopped getting paid today - you'd be out of money after %{smart_time}",
  AGE_OF_MONEY_NEG_DESC:
    "Some refer to this as the age of your money. Because yours is negative, it means that you are spending money you haven't earned yet.",
  ALL: 'All',
  ALL_CAUGHT_UP: 'All Caught Up!',
  ALL_TRANSACTIONS: 'All Transactions',
  ALMOST_THERE: 'Almost there...',
  ALREADY_LINKED_MAX: "You've already linked %{count}/%{max_link} institutions",
  AMOUNT_S: 'Amount |||| Amounts',
  AMOUNT_TO_MOVE: 'Amount to move',
  ANALYZE_SPENDING: 'Analyze Spending',
  ANALYZE_SPENDING_DESC:
    "We're analyzing your spending and creating a spending plan based on your past spending.",
  AND: 'and',
  ANYONE: 'Anyone',
  APP_NAME: 'One Goal',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ARCHIVED_RESTORE: 'Restore Category',
  ARCHIVE_BUDGET: 'Archive Category',
  ARCHIVE_BUDGET_DESC:
    'Archiving a category will hide it from your categorize views. The category will only show in your reports if there is a transaction that matches the category.',
  ARE_YOU_SURE: 'Are you sure?',
  ASSETS: 'Assets',
  ASSIGN_TO_CATEGORY: 'Assign to Category',
  AUTO_FUND_DESC:
    'When your income is categorized it is set aside in one combined category called "Runway." Money moves from your "Runway" into your other spending categories.',
  AUTO_FUND_OFF_DESC:
    'All of your income is set aside into one category called "Runway." To break the paycheck cycle, we recommend picking a day, then manually funding your categories each week from your "Runway." At first, you may need to make some sacrifices to increase your runway. But before you know it, you\'ll be stress free, funding your categories weekly, and ready to turn auto-funding on!',
  AUTO_FUND_OFF_DESC_SHORT:
    'All of your income is set aside into one category called "Runway." To break the paycheck cycle, we recommend picking a day, then manually funding your categories each week from your "Runway."',
  AVAILABLE: 'Available',
  AVERAGE_INCOME: 'Average Income',
  AVERAGE_SPENDING: 'Average Spending',
  BALANCE_S: 'Balance |||| Balances',
  BANK_CONNECTIONS: 'Bank Connections',
  BEEN_INVITED: "You've been invited to join One Goal!",
  BEEN_INVITED_TEAM: "You've been invited to join a One Goal Team!",
  BILLING: 'Billing',
  BILLING_AND_PLANS: 'Billing & Plans',
  BILLING_DESCRIPTION: '',
  BILLS_ORDERED: 'Bills are ordered by due date',
  BILL_AMOUNT: 'Bill Amount',
  BILL_S: 'Bill |||| Bills',
  BREAK_PAYCHECK_CYCLE: 'Stop living paycheck to paycheck!',
  BROKERAGE: 'Brokerage',
  BROWSER: 'Browser',
  BUDGET_NEGATIVE_ON: "It looks like you won't have enough saved on %{date}",
  BUDGET_SETUP: 'Getting Started',
  BUDGETS_FROM_ACCOUNT: 'Categories connected to this account',
  BUDGETS_FUND_EVERY: 'Categories fund every',
  BUDGETS_NO_ACCOUNT: 'Categories not connected to an account',
  BUDGETS_RESET:
    "We've reset your categories to zero and you're ready to start over. Please reach out if we can help set up your new spending plan!",
  BUDGETS_WONT_FUND_ON:
    "It looks like your spending categories won't be able to fund on %{date}",
  BUDGET_ACCOUNT_DESC:
    'This is the account the bill is coming from. It is used for projecting what your account balances will be in the future based on the amount set in this category.',
  BUDGET_AMOUNT: 'Budget Amount',
  BUDGET_MAXIMUM: 'Category Maximum',
  BUDGET_NAME: 'Spending Plan Name',
  BUDGET_PAST_DUE: '%{name} (past due %{nextDate})',
  BUDGET: 'Envelopes',
  BUDGET_S: 'Category |||| Categories',
  BUDGET_ZEN: 'Spending Plan Zen!',
  BY_FOCUSING_ON:
    "Let's take a minute to set up your spending plan. This should only take a few minutes, and you can adjust your spending plan at any time.",
  BY_REMOVING:
    'By removing this connection, all of the listed accounts will no longer update automatically, previous transactions will be removed, and new transactions will no longer be sent to %{appName}.',
  CANCEL: 'Cancel',
  CANT_CANCEL: 'Active Subscription',
  CANT_CANCEL_DESC:
    'You must cancel your subscription before you can delete your account',
  CANT_REMOVE_OWNER: "Can't remove owner",
  CANT_REMOVE_OWNER_DESC:
    "Have the owner reach out to support if you'd like to transfer ownership",
  CAN_GIFT_OG:
    "You can purchase a year (or several years) of One Goal for someone else! Send us a message for how many codes you'd like, once you've paid, we'll send you the codes you can share!",
  CASH_FLOW: 'Actual Cash Flow',
  CASH_FLOW_NEG:
    "Looks like you are spending MORE than you're making! Try to adjust your plan so that you plan on spending less than you make!",
  CASH_FLOW_POS:
    "You're planning on spending less than you're making! Good job! Stay on top of it, and you'll continue to increase your runway.",
  CASH_FLOW_ZERO:
    "You've given every dollar a job! Great job! Every penny is accounted for, and you can always adjust your spending plan if you need to.",
  CATEGORIZING: 'Categorizing your past transactions...',
  CATEGORIZE: 'Categorize',
  CATEGORIZE_COUNT_TRANSACTIONS:
    'Categorize %{smart_count} Transaction |||| Categorize %{smart_count} Transactions',
  CATEGORIZE_MANY: 'Categorize many',
  CATEGORIZE_SPEND: 'Categorize your spending',
  CATEGORIZE_SPEND_DESC:
    'Take action on your plan! Track your spending by adding transactions to your categories. With linked accounts it is as simple as drag and drop.',
  CATEGORIZED_BY_NAME: 'Categorized by %{name}',
  CATEGORIZED_BY_PLAID: 'Categorized by data',
  CATEGORIZED_BY_RULE: 'Categorized by rule',
  CATEGORY_FUNDS_ON: '%{name} will be funded %{amount} %{frequency} %{date}',
  CATEGORY_NO_FUNDING: '%{name} will be not funded',
  CATEGORY_PARENT: 'Parent Category',
  CHANGE_FUNDING_DAY: 'Change Funding Day',
  CHANGE_LANGUAGE: 'Change Language',
  CHANGE_ONE_GOAL: 'Change My Goal |||| Change Our Goal',
  CHECKING_CASH: 'Checking / Cash',
  CHECK_OUT_OG: 'Check out One Goal!',
  CHECK_OUT_OG_2:
    'Check out One Goal! Spenders & Savers unite to set goals, create a unified spending plan, and follow that plan together!',
  CHOOSE_ANOTHER_DAY: 'Choose another day',
  CHOOSE_FILE: 'Choose File',
  CODES: 'Codes',
  COLOR: 'Color',
  COMBINED_ACCOUNTS: 'Combined Accounts',
  CONDITION_ADD: 'Add Condition',
  CONDITION_REMOVE: 'Remove Condition',
  CONDITION_S: 'Condition |||| Conditions',
  CONDITION_S_WHEN_MET:
    'When above condition is met: |||| When above conditions are met:',
  CONFIRM_REMOVE_MEMBER_DESC:
    'They will no longer be able to view your spending plan.',
  CONFIRM_REMOVE_NAME: 'Are you sure you want to remove %{name}?',
  CONGRATS_ONBOARDED:
    "You did it! You're on your way to accomplishing your goals, check in at least weekly and you'll be unstoppable!",
  CONGRATS_SUBSCRIBING:
    "Congrats on joining one Goal! We can't wait to see what you can accomplish!",
  CONTACT_SUPPORT: 'Contact Support',
  CONTAINS: 'Contains',
  CONTINUE: 'Continue',
  COPIED: 'Copied %{text}',
  COPY_LINK: 'Copy Link',
  COPY_LINK_ONLY: 'Copy Link Only',
  COPY_SHARE_MSG: 'Copy Share Message with Link',
  COUNT_TRANSACTIONS:
    '%{smart_count} Transaction |||| %{smart_count} Transactions',
  CREATE_AN_ACCOUNT: 'Create an account or sign in to start using One Goal',
  CREATE_A_UNIFIED:
    'Create a unified spending plan in minutes, and start following that plan for free!',
  CREATE_BUDGET: 'Create Spending Plan',
  CREATE_BUDGET_FOR_ME: 'Create Spending Plan for Me',
  CREATE_COUNT_CATEGORY:
    'Create %{smart_count} Category |||| Create %{smart_count} Categories',
  CREATE_ONE_GOAL: 'Create One Goal',
  CREATE_OWN_BUDGET: "I'll Create my Own Spending Plan",
  CREATE_OWN_BUDGET_DESC:
    'If you prefer, you can create your own spending plan manually',
  CREATE_NEW_BUDGET:
    'Would you like to create a new spending plan, or view an existing spending plan?',
  CREATE_TRANSACTION: 'Create Transaction',
  CREATING_BUDGET: 'Creating your spending plan from your past spending...',
  CREATING_RULES: 'Creating rules for categorizing transactions...',
  CREDIT: 'Credit',
  CREDIT_CARD: 'Credit Card',
  CURRENT: 'Current',
  CURRENT_BALANCE: 'Current Balance',
  CUSTOM: 'Custom',
  CUSTOM_AMOUNT: 'Custom Amount',
  DASHBOARD: 'Dashboard',
  DATE: 'Date',
  DATE_FORMAT: 'Date Format',
  DAY_S: 'Day |||| Days',
  DEFAULT: 'Default',
  DEFAULT_BUDGET_VIEW: 'Default Spending Plan View',
  DEBT_CHAT:
    "Looks like you have more debt than cash available! This means you're spending money you haven't earned yet. We're going to take the %{available} and move it into your spending categories. Think of this like putting your cash into separate spending envelopes. Because you have more debt than cash, it'll be like you're borrowing money from your runway. Your goal should be to increase your runway so that you can pay off that debt, and stop living paycheck to paycheck.",
  DELETE: 'Delete',
  DELETED_ALL_BUDGETS:
    'Done. We deleted all your categories, please reach out if we can help set up your new spending plan!',
  DELETE_ACCOUNT: 'Delete Account',
  DELETE_ALL: 'Delete All',
  DELETE_ALL_MY: 'Delete all my categories',
  DELETE_ALL_BUDGETS_DESC:
    "You'll delete all your categories, and you'll need to create new categories to keep using One Goal.",
  DELETE_AND_MERGE_BUDGET: 'Delete & Merge Category',
  DELETE_BUDGET: 'Delete Category',
  DELETE_DATA: 'Delete my data from One Goal',
  DELETE_DATA_DESC:
    'You will be logged out, and your account will be queued for deletion. We will remove all of your data from One Goal. Once your data is deleted, it cannot be recovered, and you will have to create a new account to use One Goal again.',
  DELETE_TRANSACTION: 'Delete Transaction',
  DELETING_TRANSACTION:
    'Deleting this transaction will move money back into each category where it was taken from.',
  DEMO_RESET: 'Reset Demo',
  DEPOSIT: 'Deposit',
  DESCRIPTION: 'Description',
  DEV_ONLY: 'Dev only',
  DEV_THINGS: 'Dev Things',
  DIFFERENCE_EARNED_LESS:
    'Whoops, looks like you earned less than your plan during this time',
  DIFFERENCE_EARNED_MORE:
    'Sweet, you earned more than your plan during this time',
  DIFFERENCE_SPENT_LESS: 'You spent less than your plan during this time',
  DIFFERENCE_SPENT_MORE:
    'Whoops, looks like you spent more than your plan during this time',
  DIFFERENCE_ZEN: 'Awesome, looks like this spending category is spot on!',
  DISMISS: 'Dismiss',
  DONE: 'Done',
  DOWNLOAD: 'Download',
  DOWNLOAD_TEMPLATE: 'Download Template',
  DOWNLOAD_THE_APP:
    'Download the iOS or Android app to enable push notifications',
  DOWNLOAD_TRANSACTIONS: 'Download Transactions',
  DUE_DATE: 'Due Date',
  DUE_ON_DATE: 'Due: %{date}',
  DUPLICATE: 'Duplicate',
  EARNED: 'Earned',
  EDIT: 'Edit',
  EDIT_ACCOUNT: 'Edit Account',
  EDIT_BILL: 'Edit Bill',
  EDIT_BUDGET: 'Edit Category',
  EDIT_CONNECTION_WITH: 'Edit Connection with One Goal',
  EDIT_INCOME: 'Edit Income',
  EDIT_SAVINGS: 'Edit Savings',
  EDIT_STYLE: 'Edit Style',
  EDIT_TRANSACTION: 'Edit Transaction',
  EDUCATION: 'Education',
  EMAIL: 'Email',
  EMAIL_FRIEND: 'Email a friend',
  EMAIL_ME_WHEN: 'Email me when:',
  EMAIL_NOTIFICATIONS: 'Email Notifications',
  ENABLE_PUSH_NOTIFICATIONS: 'Enable Push Notifications',
  ENABLE_PUSH_PROMPT:
    "Now that you've linked your accounts, turn on push notifications to be notified of any time there is a new transaction",
  END: 'End',
  END_DATE: 'End Date',
  ENTER_AMOUNT_CHECK:
    "Enter the expected amount that hits your bank account. You can add more than one income, don't worry you can change this at any time.",
  ENTER_START_AND: 'Enter start and end dates for search',
  ENTER_START_END:
    "Enter the start and end dates for the transactions you'd like to see. This is great for preparing your taxes!",
  ERROR_ITEM: "Whoops, looks like there's an error with this connection",
  ERROR_UNKOWN: 'Houston, we have a problem',
  ERROR_UNKOWN_DESC:
    "Well this is embarrassing, we're not sure what happened. If it keeps happening, please let us know.",
  ERROR_WITH_ACCOUNT: "Darn, looks like there's an error connecting to %{name}",
  EVERY_NUM_FREQUENCY: 'Every %{frequency}',
  EXCLUDED_CATEGORIES: 'Excluded Categories',
  EXIT: 'Exit',
  EXIT_DEMO: 'Tap to exit DEMO',
  EXPECTED_DATE: 'expected on %{date}',
  EXPENSE_S: 'Expense |||| Expenses',
  EXPORT_CSV: 'Export CSV',
  EXPORT_TRANSACTIONS: 'Export Transactions',
  EXTRA_INCOME_TO: 'Extra Money 🎉',
  FEATURES: 'Features',
  FEEDBACK_FAVORITE:
    'What is your favorite part of using %{appName} these past few months?',
  FEEDBACK_IMPROVEMENTS: 'How can we improve %{appName} for you?',
  FEEDBACK_REACH_US:
    'Remember, you can always reach us through the "Send Feedback" button in the menu.',
  FEEDBACK_REVIEW:
    'When you have time, it really helps when you leave a review on the App Store, Google Play, or on social 😊',
  FEEDBACK_THANKS:
    'Thanks for your feedback! It helps us make the app better for you.',
  FILL_BUDGETS: 'Fund Spending Categories',
  FIRST_DUE_DAY: '1st Due Day',
  FIRST_PAY_DAY: '1st Pay Day',
  FIX: 'Fix',
  FIX_NOW: 'Fix Now',
  FOLLOW_SOCIAL: 'Follow us on Social!',
  FREQUENCY: 'Frequency',
  FREQUENTLY_ASKED_Q: 'Frequently Asked Questions',
  FRIDAY: 'Friday',
  FRIEND_S_SUBSCRIBED:
    'friend subscribed with my link |||| friends subscribed with my link',
  FROM_BUDGET_TO_BUDGET: 'From %{from} for %{to}',
  FUNDED_COUNT_BUDGETS:
    'Funded %{smart_count} Category |||| Funded %{smart_count} Categories',
  FUNDING: 'Funding',
  FUNDING_CUSTOM: 'Custom Funding',
  FUNDING_FREQUENCY: 'Funding Frequency',
  FUND_BUDGETS: 'Fund Envelopes',
  FUND_BUDGETS_AUTO: 'Auto-Fund Envelopes',
  FUND_BUDGETS_INDIVIDUAL: 'Envelopes fund on their own schedule',
  FUND_NAME: 'Fund %{name}',
  FUND_YOUR_BUDGETS: 'Fund your spending categories',
  FUND_YOUR_BUDGETS_DESC:
    'With your accounts linked, you can now allocate that money into your spending categories!',
  GIFTING_OG: 'Gifting One Goal',
  GIFT_S: 'Gift |||| Gifts',
  GIFT_ONE_GOAL: 'Gift One Goal',
  GIVE_SOMEONE_A: 'Give someone a year of One Goal for Christmas!',
  GOAL_AMOUNT: 'Goal Amount',
  GOAL_DATE: 'Goal Date',
  GOT_IT: 'Got it!',
  GREAT: 'Great! ',
  GREAT_LINK_ACCOUNTS:
    "Great! To help you reach your one goal, we'll start by connecting your accounts.",
  GROUP_S: 'Group |||| Groups',
  GROUP_BY: 'Group By',
  GROUP_CONVERT_CONDITION: 'Turn into Group',
  GROUP_REMOVE: 'Remove Group',
  HAVE_QUESTIONS: 'Have questions or want to send us feedback?',
  HELP: 'Help',
  HELP_ME_RESET: 'Help me restart',
  HERES_A_FEW:
    "Here's a few bills to get you started. Tap each suggestion to add it to your spending plan. You can edit amounts and due dates on the next page.",
  HERES_A_FEW_INCOME:
    "Here's a few income sources to get you started. Tap each suggestion to add it to your spending plan. You can edit amounts and expected dates on the next page.",
  HERES_THE_FUN: "Alright, here's the fun part!",
  HEY_NAME: 'Hey %{name}!',
  HEY_THERE: 'Hey There!',
  HISTORICAL_DESC:
    "Categorizing this transaction doesn't change the category balance, because it came from before resetting your spending plan.",
  HMMM: 'Hmmm...',
  HOME: 'Home',
  HONEY_WHAT: "Honey?! What's this charge for?",
  HOW_IS_APP: 'How are you liking %{appName}?',
  IF: 'If',
  IF_DELETE_AND_MERGE_BUDGET:
    "We'll prompt you to select a different category to update past transactions and update existing rules to the new category.",
  IF_DELETE_BUDGET:
    'This category will no longer show in reports or on your plan.',
  IF_YOU_SHARE:
    "If you share accounts with your spouse, we'll hide the description - and add a bow to the transaction",
  IGNORE: 'Ignore',
  IGNORED: 'Ignored',
  IGNORED_UNCATEGORIZED:
    'Great! We\'ve marked any uncategorized transaction as "Ignored". You can categorize them in the future if you\'d like.',
  IGNORE_ALL: 'Ignore All',
  IGNORE_ALL_DESC:
    "Ignoring all your uncategorized transactions is a great way to quickly catch up and restart your budgeting efforts, but you'll miss out on detailed reports of your past spending.",
  IGNORE_ALL_UNCATEGORIZED: 'Ignore all uncategorized transactions',
  IGNORE_TRANSACTION: 'Ignore Transaction',
  IGNORING_TRANSACTION:
    'Ignoring this transaction will take money from your "Runway" category.',
  IMPORT_AS_HISTORICAL: 'Import as Historical Transactions',
  IMPORT_AS_HISTORICAL_DESC:
    "Account balances and category balances won't change from these transactions. The transactions will be imported as historical transactions for reports only.",
  IMPORT_BUDGET: 'Import your spending plan from Mint',
  IMPORT_BUDGET_DESC:
    "Don't want to start from scratch? Simply upload your Mint transactions and we'll create a spending plan based on your Mint categories.",
  IMPORT_BUDGET_REVIEW_BUDGET:
    "Alrighty! Here's a preview of your spending plan based on your past spending. You can deselect any categories you don't want to include. After importing your spending plan, you'll be able to adjust the category amounts.",
  IMPORT_BUDGET_REVIEW_SPENDING:
    "Here's an overview of your spending from Mint. We recommend using the past 3-12 months of transactions to create your spending plan.",
  IMPORT_COUNT_TRANSACTIONS:
    'Import %{smart_count} Transactions |||| Import %{smart_count} Transactions',
  IMPORT_SUCCESSFUL: 'Whoot! Your transactions have been added to One Goal!',
  IMPORT_TRANSACTIONS: 'Import Transactions',
  INCLUDE: 'Include',
  INCLUDE_TRANSACTIONS: 'Include transactions',
  INCLUDES_UNCATEGORIZED: 'Includes Uncategorized Transactions',
  INCOME_HEALTH: 'Runway Health',
  INCOME_ORDERED: 'Income is ordered by next payday',
  INCOME_SAVED: 'Runway',
  INCOME_VS_EXPENSES: 'Income vs Expenses',
  INSIGHTS: 'Insights',
  INVERT_AMOUNT: 'Invert Amount',
  INVERT_AMOUNT_DESC:
    'Changes your positive transactions to negatives, and negative transactions to positives.',
  INVESTMENT_S: 'Investment |||| Investments',
  INVITE_OTHERS: 'Invite others to join your spending plan',
  INVITE_OTHERS_DESC:
    "We'll send an email with a unique link that will allow them to join your spending plan. They'll be able to do everything you can: View and edit your spending plan, categorize transactions, and manage your accounts.",
  INVITE_SENT_TO_EMAIL: 'Invite sent to %{email}',
  IN_ACCOUNTS: 'In Accounts',
  IN_ALL_BUDGETS: 'In Envelopes',
  IN_ALL_BUDGETS_DESC:
    'This is the total amount in all your spending envelopes',
  ISSUE_COPYING: 'There was an issue copying the text',
  IS_CREDIT_CARD_BILL: "Is this a Credit Card bill that you'll pay in full?",
  IS_GIFT: 'This is a gift',
  IS_GIFT_EXCL: 'This is a gift!',
  JOINED_ONE_GOAL: 'Joined One Goal!',
  JOINING_ONE_GOAL: 'Joining One Goal...',
  JOIN_ONE_GOAL: 'Join One Goal',
  JOIN_TEAM: 'Join Team',
  JUST_THE_ONE: 'Just The One Goal Team',
  HANG_IN_THERE: 'Hang in there...',
  KNOW_SOMEONE:
    'Know someone that needs One Goal? Send them an invite link and help them set up their first spending plan!',
  LAST_MONTH: 'Last Month',
  LAST_MONTHS: 'Last %{months} Months',
  LAST_THIRTY_DAYS: 'Last 30 days',
  LAST_UPDATED: 'Last Updated',
  LAST_YEAR: 'Last Year',
  LATER: 'Later',
  LEARN_MORE: 'Learn More',
  LEARN_MORE_AT: 'Learn more at %{name}',
  LEFT: 'Left',
  LETS_CREATE_BILL:
    "Let's create your first bill to pay off that debt. When you have extra money in this category, just pay more towards the debt!",
  LETS_CREATE_SAVINGS:
    "Let's create your first savings category to help you accomplish your goal!",
  LETS_DO_THIS: "Let's do this!",
  LETS_SAVE: 'What are you saving for?',
  LET_S_GET: "Let's get started",
  LIABILITIES: 'Liabilities',
  LIMIT: 'Limit',
  LINK_ACCOUNT_S: 'Link Account |||| Link Accounts',
  LINK_ACCOUNT_VIA: 'Link Account via %{vendor}',
  LINK_ACCOUNTS_DESC:
    'Manually add an account, or link your bank/credit card to have your transactions automatically added to One Goal',
  LINK_ACCOUNTS_DONE_ANALYZE:
    "Once you're done linking accounts, we'll analyze your spending, and create your spending plan automatically!",
  LINK_ACCOUNTS_DONE_BUDGET:
    "Once you're done linking accounts, we'll walk you through creating your spending plan.",
  LINK_ACCOUNTS_RECOMMENDATION:
    "Let's start by linking all of your relevant spending accounts! We recommend linking your checking account, and any credit cards you use regularly.",
  LINK_OTHER_ACCOUNTS: 'Do you have other accounts you would to link?',
  LINK_TO_PENDING: 'Link to Pending Transaction',
  LOADING_MORE_DATA: 'Loading more data...',
  LOAN: 'Loan',
  LOOKS_GOOD_CHAT:
    "Looking good! We're going to take the %{available} and move it into your spending categories. Think of this like putting your cash into separate spending envelopes.",
  LOOKS_IS_GIFT: 'Looks like this transaction is a gift!',
  LOOKS_LIKE_OVER_50:
    "Looks like you have over 50 transactions that need review! We get it, life gets busy, if you'd like to reset your spending categories and transactions you can!",
  LOOKS_LIKE_PLAID:
    'Looks like Plaid is having issues connecting to this bank, but your account has been updated in the last 24 hours, so it may not be affecting you yet.',
  LOVE_TO_HEAR: "We'd love to hear from you!",
  MAKE_ENVELOPE: 'Make Envelope',
  MAKE_ENVELOPE_DESC: 'Separate funds from %{name}',
  MANAGE: 'Manage Access',
  MANAGE_ACCESS: 'Manage Access',
  MANAGE_SUBSCRIPTION: 'Manage Subscription',
  MARKETING: 'Marketing',
  MARK_COUNT_REVIEWED:
    'Mark %{smart_count} Reviewed |||| Mark %{smart_count} Reviewed',
  MARK_REVIEWED: 'Mark Reviewed',
  MARK_REVIEWED_DESC:
    'Marking all your transactions as reviewed will get them off your todo list. You will still be able to change the category later.',
  MARK_REVIEWED_FIRST_CATEGORIZE: 'Categorize Transaction First',
  MARK_REVIEWED_FIRST_CATEGORIZE_DESC:
    'You need to select a category before this transaction can be marked as reviewed',
  MATCHES_ALL: 'Matches All',
  MATCHES_ANY: 'Matches Any',
  ME: 'Me',
  MERCHANT: 'Merchant',
  MERGE: 'Merge',
  MESSAGE: 'Message',
  MISSING_PERMISSION: 'Missing Permission',
  MISSING_PERMISSION_MSG:
    "Whoops, looks like you didn't create this connection. You can only edit this connection if you created it.",
  MISSING_PERMISSION_GROUP_DESC:
    "Whoops, looks like you don't have permission to view this spending plan, or you may have input the URL incorrectly.",
  MONDAY: 'Monday',
  MONEY_BEHIND: '%{money} Behind',
  MONEY_DUE_DATE: '%{money} due: %{date}',
  MONEY_EXTRA: '%{money} Extra',
  MONTH_S: 'Month |||| Months',
  MOVE_MONEY: 'Move Money',
  MOVE_MONEY_STOLE:
    'Well technically you already stole %{amount}, because negative envelopes are already taken from %{name}',
  MOVE_MONEY_TO_ENVELOPE:
    'You can only move money to/from another envelope. "%{name}" is not an envelope.',
  MY_BUDGET_SETTINGS: 'My Spending Plan Settings',
  MY_ONE_GOAL: 'My Goal |||| Our Goal',
  NAME: 'Name',
  NAME_ACCOUNT: 'Name this account',
  NAME_BILL: 'Name this bill',
  NAME_BUDGET: 'Name this category',
  NAME_CREDIT_ACCOUNT: 'Name this credit account',
  NAME_LOAN: 'Name this loan',
  NAME_PAYCHECK: 'Income Name',
  NAME_RULE: 'Name Rule',
  NAME_SAVINGS_BUDGET: 'Name this savings category',
  NEEDED: 'Needed',
  NEED_HELP: 'Need some help?',
  NEED_FRESH_START: 'Need a fresh start?',
  NEEDS_REVIEW: 'Needs Review',
  NEEDS_REVIEW_DESC:
    'Set the category and save this transaction to mark it as reviewed',
  NEGATIVE: 'Negative',
  NEGATIVE_BUDGETS: 'Negative Envelopes',
  NEGATIVE_BUDGETS_STEAL: 'Negative envelopes steal from %{name}',
  NEGATIVE_BUDGETS_WILL: "You'll need to move money from another category",
  NET_WORTH: 'Net Worth',
  NEVERMIND: 'Nevermind',
  NEW_REPLIES: 'Want to be notified of new replies?',
  NEW_TRANSACTION_S: 'New Transaction |||| New Transactions',
  NEW_TRANSACTION_S_N:
    '%{smart_count} New Transaction |||| %{smart_count} New Transactions',
  NEW_VERSION_AVAILABLE: "There's a new version of One Goal Available",
  NEXT: 'Next',
  NEXT_BILL: 'Next Bill',
  NEXT_BUDGET_DATE_SET: 'Next %{name} date: %{nextDate}',
  NEXT_PAY_DAY: 'Next Pay Day',
  NONE: 'None',
  NOPE_I_GOT_THIS: 'Nope I got this',
  NOTE_S: 'Note |||| Notes',
  NOTIFICATIONS: 'Notifications',
  NOTIFY_BUDGET_READY:
    'This can take up to a minute, if it takes any longer - send us a message by tapping the button below.',
  NOTIFY_WHEN: 'There are %{count} or more new transactions',
  NOT_A_VALID: 'Not a valid invite',
  NOT_A_VALID_DESC:
    'Whoops! Looks like you may have copied the link wrong, the link expired, or this invite may have been removed. Please reach out to the person that sent you this link to get another!',
  NOT_NOW: 'Not Now',
  NOT_YOU: 'Not you?',
  NOW_ENTERING_DEMO:
    "<h1>Now Entering Demo Mode!</h1><p>Want to show a friend One Goal, but don't want to share your personal info? That's what demo mode is for!</p><p>Right now it's a view only demo, but we'll be adding abilities to edit on the fly so that you can  show off what One Goal can do.</p><p>As always, please let us know what else you'd like to see!</p>",
  NO_ACCOUNT_BUDGETS:
    "Looks like you haven't linked any spending categories to this account. To see projected transactions you need to tell One Goal what spending categories you plan to have come from this account.",
  NO_BANK_ACCOUNTS:
    'You can manually track your spending plan, or make it easier by linking your bank accounts.',
  NO_BUDGETS_HERE: 'No spending categories yet...',
  NO_DUE_DATE_SET: 'No due date set',
  NO_FUNDING: 'No Funding',
  NO_INCLUDED_ACCOUNTS: 'No included accounts',
  NO_PAYCHECK_DATE: 'No date set',
  NO_PENDING_TRANSACTION: 'No Pending Transaction',
  NO_PEND_TRANS_BTW:
    'No unprocessed pending transactions between %{start} - %{end}',
  NO_REPEAT: 'One Time',
  NO_TRANSACTIONS_BTW: 'No transactions between %{start_date} - %{end_date}',
  NO_TRANSACTIONS_YET: 'No transactions yet',
  OG_CAR_MAINTENANCE: 'Car Maintenance',
  OG_CATEGORY: 'Category from Bank',
  OG_CATEGORY_DESC: 'Used for auto-categorizing transactions',
  OG_CHARITY: 'Charity/Tithing',
  OG_CHILDCARE: 'Childcare',
  OG_CLOTHING: 'Clothing',
  OG_CREDIT_CARD: 'Credit Card',
  OG_DIGITAL_SERVICES: 'Digital Services',
  OG_EDUCATION: 'Education',
  OG_ENTERTAINMENT: 'Entertainment',
  OG_FAMILY: 'Family',
  OG_FEES: 'Fees',
  OG_FINANCIAL_PLANNING: 'Financial Planning',
  OG_GAS: 'Gas',
  OG_GOVERNMENT_DEPARTMENTS: 'Government Departments',
  OG_GOVERNMENT_TAXES: 'Taxes',
  OG_GROCERIES: 'Groceries',
  OG_HOME_IMPROVEMENT: 'Home Improvements',
  OG_INCOME: 'Income',
  OG_INSURANCE: 'Insurance',
  OG_INTERNET: 'Internet',
  OG_INVESTMENTS: 'Investments',
  OG_LEGAL_SERVICES: 'Legal Services',
  OG_LOAN: 'Loans',
  OG_MEDICAL: 'Medical',
  OG_MERCHANDISE: 'Shopping',
  OG_MORTGAGE: 'Mortgage',
  OG_PERSONAL_CARE: 'Personal Care',
  OG_PETS: 'Pets',
  OG_PHONE: 'Phone',
  OG_PREMIUM_BENEFIT_1: 'See all your accounts in one place!',
  OG_PREMIUM_BENEFIT_2: 'Account balances sync with your bank automatically',
  OG_PREMIUM_BENEFIT_3: 'Transactions are automatically sent to One Goal!',
  OG_PREMIUM_BENEFIT_4: 'Drag and drop to categorize transactions',
  OG_PREMIUM_BENEFIT_5: 'Get Priority Support',
  OG_RENT: 'Rent',
  OG_RESTAURANTS: 'Restaurants',
  OG_SERVICES: 'Services',
  OG_TRANSFER: 'Transfer',
  OG_TRANSPORTATION: 'Transportation',
  OG_TRAVEL: 'Travel',
  OG_UNKNOWN: 'Unknown',
  OG_UTILITIES: 'Utilities',
  OH_NO_LOOKS:
    'Oh no! Looks like Plaid is having issues connecting to this bank, which could affect how quickly your account balances and transactions are updated. Plaid is aware of the issue, and are trying to sort it out',
  OKAY: 'Okay',
  ON_TRACK: 'On Track',
  ONCE_CURRENT:
    'Once the current billing period ends, you will no longer have access to One Goal.',
  ONE_GOAL: 'One Goal',
  ONE_GOAL_DEMO: 'One Goal Demo',
  ONE_GOAL_PLAID: 'One Goal uses %{vendor} to connect to %{name}',
  ONE_GOAL_RESPONSE_TIME: 'One Goal will typically respond within a few hours.',
  ONLY_AVAILABLE_ON: 'Only available on the web',
  ONLY_NAME_CAN_EDIT: 'Only %{name} can edit this connection',
  OPEN: 'Open',
  OPEN_APP_IN: 'Open %{appName} in...',
  OPEN_GROUP_IN: 'Open Group in Firestore',
  OPEN_STORE: 'Open %{store}',
  OPEN_USER_IN: 'Open User in Firestore',
  OR: 'or',
  OTHER: 'Other',
  OUT_OF_DEBT: 'Get out of debt',
  OUT_OF_DEBT_ON_DATE: "Follow your plan and you'll be out of debt on %{date}",
  OVERFLOW_TO: 'Send my extra funds to my One Goal',
  OVERSPENT: 'Overspent!',
  OWNER: 'Owner',
  PAGE_NOT_FOUND: "Whoops, this page doesn't exist!",
  PAGE_NOT_FOUND_DESC:
    'You may need to update your bookmarks. If you keep seeing this page, please sign in and let us know.',
  PAID_FROM_ACCOUNT: 'Paid From Account',
  PAID_VIA: 'Paid via',
  PAID_VIA_PARTNER: 'Paid via Partner',
  PAST_DUE: 'Past Due',
  PAYCHECK_AMOUNT: 'Income Amount',
  PENDING: 'Pending',
  PENDING_INVITES: 'Pending Invites',
  PENDING_TRANSACTION: 'Pending Transaction',
  PLAID_IS_HAVING:
    'Plaid is having some issues connecting to this bank, but your account has been updated recently, so you might not be affected.',
  PLAID_WEBHOOKS: 'Plaid Webhooks',
  PLAN: 'Plan',
  PLANNED_AMOUNT: 'Planned: %{amount}',
  PLANNED_INCOME: 'Planned Income',
  PLANNED_EXPENSES: 'Planned Expenses',
  PLANNED_CASH_FLOW: 'Planned Cash Flow',
  PLAY_DEMO_VIDEO: 'Play Demo Video',
  PLEASE_ENABLE_PUSH:
    'Please enable push notifications for One Goal in the Settings App',
  PLEASE_SUBSCRIBE: 'Please Subscribe',
  PLEASE_SUBSCRIBE_PROMPT:
    "If you're enjoying One Goal, please subscribe! If you choose not to subscribe, please let us know why, we'd love to make it better for you!",
  PRICE: 'Price',
  PRIOR_YEAR: 'Last Year',
  PROJECTED_TRANSACTIONS: 'Projected Transactions',
  PROJECTED_TRANSACTIONS_SPREADSHEET: 'Projected Transactions Spreadsheet',
  PROJECTIONS: '%{name} Projections',
  PROJECT_GAIN:
    "Based on your spending plan, we project that you'll save %{annual} every year if you stick to your plan!",
  PROJECT_LOSS:
    "Based on your spending plan, we project that you'll lose %{annual} every year if you don't make some changes.",
  PROJECT_NONE:
    "Based on your spending plan, we project that you'll save %{annual} every year if you stick to your plan.",
  PROMO_NOT_AVAILABLE: 'This promo is not available on this device',
  PROMO_NOT_VALID: "This promo URL isn't valid",
  PROMO_NOT_VALID_DESC:
    "Don't worry, we'll show you the default pricing instead",
  PROPERTY: 'Property',
  PURCHASE_GIFT: "I'd like to purchase a One Goal Gift code",
  PUSH_NOTIFICATIONS: 'Push Notifications',
  RATE_US: 'Leave a Review',
  RATE_US_PLEASE: 'Could you please leave us a review?',
  RATE_ON_STORE: 'Rate us on %{store}',
  RECENT_TRANSACTIONS: 'Recent Transactions',
  RELEASES: 'Releases',
  RELEASE_NOTES: 'Release Notes',
  RELINK_ACCOUNT: 'Relink Account',
  RELOAD: 'Reload',
  REMOVE: 'Remove',
  REMOVED_BUDGET_FROM_GROUP: 'Removed %{budgetName} from %{groupName}',
  REMOVED_BUDGET_FROM_GROUP_HEADER:
    'Categories should only belong to one group',
  REMOVED_NEEDS_REVIEW:
    'Got it! You\'ll no longer see "Needs Review" on those past transactions',
  REMOVE_ACCOUNT: 'Remove Account',
  REMOVE_CONNECTION: 'Remove Connection',
  REMOVE_DEBT: "Let's knock out that debt!",
  REMOVE_DEBT_DESC:
    "Remove a debt from your tracked accounts, stop spending from that credit card, and make a plan to pay it off. Once it's paid off, you'll be able to add it back.",
  REMOVE_FILTERS: 'Remove Filters',
  REMOVE_FROM_BUDGET: 'Remove from Spending Plan',
  REMOVING_ACCOUNT:
    'Removing this account, will hide the account balances and transactions from One Goal',
  RENAME: 'Rename',
  RENAME_BUDGET: 'Rename Spending Plan',
  REORDER: 'Reorder',
  REPORT_S: 'Report |||| Reports',
  REQUEST_CODES: 'Request Codes',
  REQUIRED: 'Required',
  RESETTING_YOUR_BUDGETS:
    'Resetting your envelopes will set all your envelope balances to zero. You will be able to manually fund your envelopes again to get back on track.',
  RESET_BUDGETS: 'Reset Envelopes',
  RESET_DATES: 'Update Due Dates',
  RESET_DATES_DESC:
    'Update all of your income and bill due dates automatically to reflect future due dates',
  RESET_MY_BUDGET: 'Reset My Spending Plan',
  RESTART: 'Restart',
  RETURN_TO: 'Return to %{name}',
  REVIEW_BUDGET: 'Review Spending Plan',
  REVIEW_BUDGET_DESC:
    "Before we start tracking your transactions, here's an overview of your spending plan.",
  REVIEW_SAVINGS: "Let's review your savings",
  REVIEW_SPENDING: "Sweet, now let's review your spending",
  REVIEW_TRANSACTIONS: 'Review Transactions',
  REVIEWED: 'Reviewed',
  REVIEWED_BY: 'Reviewed By',
  RULES_DESC:
    'Set up rules to automatically categorize transactions as they sync with %{appName}. Rules run in the order listed below.',
  RULE_CREATE: 'Create Rule',
  RULE_DELETE: 'Delete Rule?',
  RULE_DELETE_DESC:
    'Deleting this rule will not affect past transactions, but will stop auto-categorizing based on this rule',
  RULE_EDIT: 'Edit Rule',
  RULE_S: 'Rule |||| Rules',
  SATURDAY: 'Saturday',
  SAVE: 'Save',
  SAVE_MONEY: 'Save Money',
  SAVE_MORE_INCOME:
    'To truly stop living paycheck to paycheck, try and save another %{money} in your income.',
  SAVING_S: 'Savings |||| Savings',
  SAVING_S_GOAL: 'Savings Goal |||| Savings Goal',
  SCHEDULE_CALL: 'Schedule a 1:1 call',
  SEARCH: 'Search',
  SEARCH_DATES: 'Search Dates',
  SEARCH_TRANSACTIONS: 'Search Transactions',
  SECURITIES: 'Security |||| Securities',
  SELECT_ACCOUNT: 'Select Account',
  SELECT_BUDGET_S: 'Select Category |||| Select Categories',
  SELECT_COMMON_SAVINGS:
    'Select your common savings categories to get you started. Tap each button to add them to your spending plan. You can change the amounts and details on the next page.',
  SELECT_COMMON_SPENDING:
    'Select your common spending categories to get you started. Tap each button to add them to your spending plan. You can change the amounts and details on the next page.',
  SELECT_DESELECT_ALL: 'Select/Deselect All',
  SELECT_OG_CATEGORY: 'Select Bank Category',
  SELECT_ONE_GOAL: 'Select One Goal',
  SELECT_ONE_GOAL_EXISTING: 'Select One Goal From existing spending categories',
  SELECT_TRANSACTIONS: 'Select Transactions',
  SELECT_TRANSACTIONS_COUNT:
    'Select %{smart_count} Transaction |||| Select %{smart_count} Transactions',
  SEND_INVITE: 'Send Invite',
  SEND_FEEDBACK: 'Send Feedback',
  SEND_ME_PUSH_WHEN: 'Send me push notifications when:',
  SEND_ME_A_PUSH: 'Send me a push notification',
  SEND_US_A: 'Send us a message, we love hearing from you!',
  SENT_AT: 'Sent %{date}',
  SETTINGS: 'Settings',
  SET_ALL_MY: 'Set all my envelopes balance to zero',
  SET_GOAL_DATE: 'Change Goal Date',
  SET_NEXT_DUE_DATE: 'Set next due date',
  SET_NEXT_PAYCHECK_DATE: 'Set next income date',
  SET_ONE_GOAL: 'Set One Goal',
  SHARE: 'Share',
  SHARED_DATA: 'Shared Data',
  SHARE_COUNT_AT_PER_SHARE: '%{share_count} Shares @ %{share_price} / Share',
  SHARE_FB: 'Share on Facebook',
  SHARE_HOW_HELPED: 'Share how One Goal has helped you!',
  SHARE_MSG:
    "Hey %{name}, One Goal will walk you through how to setup your spending plan, then you can link your bank accounts via Plaid or add a manual bank account to track transactions manually. One Goal is based off of the old 'Cash Envelope' budgeting system, so all of your spending categories will have a zero balance at first. As you spend money, you will categorize transactions into the spending categories you created. If there's nothing left in the category, stop spending! And if you overspent, One Goal is really flexible, you just move money from another category to balance it out. The spending plan setup is pretty quick, but understanding the funding part is a bit tricky at first. Please reach out if you have any questions. Click this link and sign up to try it out! The link expires in a few days",
  SHARE_OG_LINK: 'Share One Goal Link',
  SHARE_ONE_GOAL: 'Share One Goal',
  SHARE_TESTIMONIAL: 'Share Testimonial',
  SHARE_TWITTER: 'Share on Twitter',
  SHOW_ACCOUNT_TRANSACTIONS: 'Show with account transactions',
  SHOW_ACCOUNT_TRANSACTIONS_DESC:
    "This can be helpful if you're trying to prevent importing a transaction that is already in %{appName}",
  SHOW_ME_HOW: 'Show me how',
  SHOW_PROJECTIONS: 'Show Projections',
  SIGNED_IN_AS: 'Signed in as: %{email}',
  SIGNING_IN: 'Signing in...',
  SIGN_IN: 'Sign In',
  SIGN_IN_TO: 'Sign in to join team',
  SIGN_IN_TO_CREATE_BUDGET:
    'Create an account or sign in to create a spending plan',
  SIGN_IN_WITH_NAME: 'Sign in with %{name}',
  SIGN_OUT: 'Sign Out',
  SIGN_UP: 'Sign Up',
  SIGNING_OUT: 'Signing Out...',
  SKIP: 'Skip',
  SMART_COUNT_DAY: '%{smart_count} Day |||| %{smart_count} Days',
  SMART_COUNT_MONTH: '%{smart_count} Month |||| %{smart_count} Months',
  SMART_COUNT_WEEK: '%{smart_count} Week |||| %{smart_count} Weeks',
  SMART_COUNT_YEAR: '%{smart_count} Year |||| %{smart_count} Years',
  SNOOZE: 'Snooze',
  SORRY_LOOKS_LIKE: 'Sorry, looks like this invite has already been claimed.',
  SORT_BY: 'Sort By',
  SO_YOU_VE:
    "So you've fallen a bit behind and want to reset your spending plan, that's ok, we're here to help",
  SPENDING: 'Spending',
  SPENDING_BY_TYPE: 'Spending by Type',
  SPENT: 'Spent',
  SPEND_WITH_CONFIDENCE: 'Spend with confidence',
  SPLIT_BY_AMOUNT: 'Split By Amount',
  SPLIT_BY_PERCENT: 'Split By Percent',
  SPLIT_TRANSACTION: 'Split Transaction',
  TRANSACTION_FIELD: 'Transaction Field',
  TRANSACTION_RULE_DEFAULT_DESC:
    "If a transaction doesn't match any of the above rules",
  TRANSFER_AMOUNT: 'Transfer Amount',
  SPLIT_TRANSACTION_S: 'Split Transaction |||| Split Transactions',
  START_DATE: 'Start Date',
  START_TYPING: 'Start Typing...',
  STATUS: 'Status',
  STEALING_FUTURE_CASH_AMOUNT:
    "Watch out! You're stealing %{amount} of income from your runway.",
  STILL_TRIALING:
    "Looks like you're still trialing. Feel free to sign up whenever you're ready to commit to One Goal! If you have any questions, please reach out!",
  SUB_ACTIVE: 'Active',
  SUB_ACTIVE_DESC: 'Thanks for subscribing to One Goal!',
  SUB_BASIC: 'Basic',
  SUB_CANCELED: 'Canceled',
  SUB_CANCELED_DESC: 'Your subscription has been cancelled.',
  SUB_EXPIRED: 'Expired',
  SUB_EXPIRING: 'Expiring',
  SUB_EXPIRING_DESC:
    'Your subscription has been cancelled, you will continue having access to premium features until your expiration date. Please 🙏 let us know why you decided to cancel',
  SUB_PAUSED: 'Paused',
  SUB_PAUSED_DESC:
    'Your subscription has been paused, you will continue having access to premium features until your expiration date. Please 🙏 let us know why you have paused your subscription',
  SUB_PREMIUM: 'Premium',
  SUB_PREPAID: 'Prepaid',
  SUB_PREPAID_DESC:
    'You have full access to premium features until your expiration date. Remember to prepay again or subscribe before your expiration date.',
  SUB_TRIALING: 'Trialing',
  SUB_TRIALING_DESC:
    "You are currently in a trial, if you choose not to subscribe, please let us know why, we'd love to make it better for you!",
  SUB_TRIALING_NO_CC_DATE:
    'You are currently on a free trial of all our premium features! You will have premium access until %{date}. Subscribe now to prevent losing your premium access!',
  SUB_TRIALING_NO_CC_DESC:
    "You are currently in a trial without a payment method on file, your linked accounts will be removed at the end of your trial if you choose not to subscribe. If you choose not to subscribe, please let us know why, we'd love to make it better for you!",
  SUB_TRIALING_NO_CC_EXPIRED_DATE:
    'Looks like your trial expired on %{date}. Please subscribe to continue to use One Goal Premium',
  SUBSCRIBE: 'Subscribe',
  SUBSCRIBE_PROMPT: 'Want help following this plan?',
  SUBSCRIBE_PROMPT_DESC:
    'Subscribe to link accounts, auto-import transactions, and accomplish your goals faster!',
  SUBSCRIBE_TO_CATEGORIZE:
    'You need an active subscription to categorize your imported transactions.',
  SUGGESTION_S: 'Suggestion |||| Suggestions',
  SUNDAY: 'Sunday',
  SURE_CANCEL_SUB: 'Are you sure you want to cancel your subscription?',
  SURE_DELETE_ACCOUNT: 'Are you sure you want to delete this account?',
  SURE_DELETE_TRANSACTION: 'Are you sure you want to delete this transaction?',
  SURE_IGNORE_TRANSACTION: 'Are you sure you want to ignore this transaction?',
  SWEET_SET_DUE: "Sweet, let's set your due dates and actual bill amounts.",
  SYNCING_BANK: 'Syncing with your bank...',
  TAG_S: 'Tag |||| Tags',
  TAG_ADD: 'Add Tag',
  TAGS_EDIT: 'Edit Tags',
  TAKE_ME_HOME: 'Take me home',
  TAP_ADD_BUDGET: 'Tap + to create a new category',
  TAP_ADJUST_SPENDING:
    "Tap a category to adjust your spending, you can guess if you need to, we'll make sure your numbers add up soon 😁",
  TAP_BILL_EDIT:
    "Tap on a bill to edit it. Your bills are sorted based on due date. If the bill is due soon, it'll be at the top. So, having correct due dates will help ensure you have the money set aside when the bill is due.",
  TAP_EDIT_AMOUNT: 'Tap to edit the amount to save, or add more savings goals.',
  TAP_HERE_TO: "Tap here to contact us, and we'll help you get it sorted out.",
  TAP_HERE_TO_RECONNECT: 'Tap here to reconnect your account.',
  TAP_PLAN: 'Tap "Plan" to adjust your spending plan.',
  TERMS_AND_PRIVACY_HTML:
    'By continuing, you are indicating that you accept our <a href="https://onegoalfinance.com/terms" target="_blank">Terms of Service</a> and <a href="https://onegoalfinance.com/privacy-policy" target="_blank">Privacy Policy</a>.',
  TESTIMONIAL_S: 'Testimonial |||| Testimonials',
  TEST_RULE_S: 'Test Rule |||| Test Rules',
  THANK_YOU: 'Thank You!',
  THIS_COULD_AFFECT:
    'This could affect how quickly your account balances and transactions are updated. Plaid is aware of the issue, and are trying to sort it out',
  THIS_INVITE_LINK:
    '🎉This invite link gets you 30 days free of linked accounts and transactions!',
  THIS_LINK_IS: 'This link is either expired or already used.',
  THIS_MONTH: 'This Month',
  THIS_WEEK: 'This Week',
  THIS_YEAR: 'This Year',
  THOSE_I_INVITE: 'Those I invite',
  THURSDAY: 'Thursday',
  TIPS_AND_TRICKS: 'Tips and Tricks',
  TODAY: 'Today',
  TOMORROW: 'Tomorrow',
  TOTAL_ACCOUNTS_CASH: 'Total Available for Spending Plan',
  TOTAL_ACCOUNTS_CASH_DESC: 'Cash - Credit',
  TOTAL_IN_ALL: 'Total In All Categories',
  TOTAL_INCOME: 'Total Income',
  TOTAL_SPENDING: 'Total Spending',
  TRANSACTION_S_BTW:
    '%{smart_count} transaction between %{startDate} - %{endDate} |||| %{smart_count} transactions between %{startDate} - %{endDate}',
  TRANSACTION_S: 'Transaction |||| Transactions',
  TRANSACTION_TYPE: 'Transaction Type',
  TRIAL_EXPIRED:
    "Looks like your trial has expired. Please subscribe to continue to use One Goal! Hey, we'd love to know why you aren't using One Goal anymore!",
  TUESDAY: 'Tuesday',
  TWICE_EVERY_MONTH: 'Twice Every Month',
  TWICE_MONTH_SIMPLE: ' 2x / Month',
  TYPE: 'Type',
  UNCATEGORIZED: 'Uncategorized',
  UNLINK_OG: 'Unlink from One Goal',
  UPCOMING_TRANSACTIONS: 'Upcoming Transactions',
  UPDATE: 'Update',
  UPDATE_CONNECTION: 'Update Connection',
  UPDATE_CONNECTION_ACCOUNT_MISSING: "Don't see the account listed?",
  UPDATE_CONNECTION_DESC:
    'Tap here to update what data is sent to %{appName} from this connection',
  UPDATE_CONNECTION_DESC_ASA:
    'Open the ASA app to change what data is sent to %{appName}',
  UPDATE_REQUIRED: 'Update Required',
  UPDATE_REQUIRED_DESC:
    "There's a new version of One Goal Available! This version has important fixes that requires an update now.",
  UPDATING_SUBSCRIPTION: 'Updating Subscription...',
  UPGRADE_PREMIUM: 'Upgrade to Premium',
  UPGRADE_PREMIUM_PARTNER_DESC:
    'Your subscription has been canceled. Visit the billing page to manage your subscription.',
  USER: 'user',
  VERSION: 'Version: %{version}',
  VIDEOS: 'Videos',
  VIEW: 'View',
  VIEW_ALL: 'View All',
  VIEWER: 'Viewer',
  VIEW_AS_PERCENT: 'View as Percent',
  VIEW_BUDGET: 'View Spending Plan',
  VIEW_CASH_FLOW: 'View my Cash Flow!',
  VIEW_IN_MONTHS: 'View in Months',
  VIEW_IN_WEEKS: 'View in Weeks',
  VIEW_IN_YEARS: 'View in Years',
  VIEW_ONLY_DESC:
    'This is a "view only" account, and can not be added to your spending plan. Only cash accounts and credit accounts can be added to your spending plan.',
  VIEW_INCOME_HEALTH: 'View Runway Health',
  VIEW_INCOME_REPORT: 'View Income Report',
  VIEW_INVESTMENTS: 'View Investments',
  VIEW_PAST_TRANSACTIONS: 'View Past Transactions',
  VIEW_PLANS: 'View Plans',
  VIEW_SPENDING_REPORT: 'View Spending Report',
  WANT_TO_SEE_MORE: 'Want to see more?',
  WANT_TO_SHOW: 'Want to show someone One Goal?',
  WARMING_ENGINES: "We're warming up our engines...",
  WEDNESDAY: 'Wednesday',
  WEEKLY_INCOME: 'Weekly Income',
  WEEK_OF: 'Week of',
  WEEK_S: 'Week |||| Weeks',
  WELCOME_ONE_GOAL: 'Welcome to One Goal!',
  WE_ARE_ON_IT: "We're on it!",
  WE_BELIEVE_IN:
    'We believe in setting goals, being flexible, and working together with complete transparency.',
  WE_D_LOVE: "We'd love to feature your review on the home page!",
  WHAT_BRINGS_YOU: 'What brings you to One Goal today?',
  WHAT_EXPECTED_INCOME: "What's your expected income?",
  WHAT_OTHER_INSIGHTS: 'What other insights would you like to see?',
  WHAT_TRANSACTIONS: 'What transactions would you like to export?',
  WHEN_BUDGETS_FILL:
    'When your categories fund, if there is any money over %{budget_max} it will be automatically moved to your One Goal! 🎉',
  WHEN_NEXT_BILL: 'When is your next %{name} bill due?',
  WHEN_NEXT_PAYCHECK: 'When is the next %{name} deposit?',
  WHERE_DID_GO: 'Where did it go?',
  WHERE_FROM: 'Where does it come from?',
  WHERE_FROM_PAST: 'Where did it come from',
  WHERE_GOING: 'Where is it going?',
  WHERE_IS_IT: 'Where is it now?',
  WHICH_ACCOUNTS:
    'Which accounts would you like included in your spending plan?',
  WHICH_ACCOUNTS_DESC:
    'We recommend including your checking account, and any credit cards you use regularly.',
  WHOOPS: 'Whoops!',
  WHOOPS_BROKE_BUDGET: 'Whoops! Looks like you overspent!',
  WHOOPS_INCOME_NEGATIVE:
    'Whoops, looks like your "Runway" is negative. This means you are spending money you have not earned yet 😬',
  WHOOPS_LOOKS_LIKE:
    'Whoops! Looks like Plaid is having some issues connecting to this bank, which may affect how quickly your account balances and transactions are updated. Plaid is aware of the issue, and are trying to sort it out.',
  WHOOT_LOOKS_LIKE:
    'Whoot! Looks like Plaid is connected to this account correctly, and the majority of requests to your bank is working as expected.',
  WHO_CAN_SEE: 'Who can see this testimonial:',
  WHO_HAS_ACCESS: 'Who has access',
  WOOT_WOOT: 'Whoot whoot!',
  YEARLY_INCOME: 'Yearly Income',
  YEARS_MONTHS: '%{years} %{months}',
  YEAR_S: 'Year |||| Years',
  YESTERDAY: 'Yesterday',
  YOUR_ACCOUNT_S: 'your account |||| your accounts',
  YOUR_INCOME_BUDGET:
    "Your Runway category should be your one goal. When you have extra money it should be set aside in your Runway category to be spent later. You'll be free from the dreaded paycheck-to-paycheck nightmare soon!",
  YOUR_PLAN: 'Your Plan',
  YOUR_SUBSCRIPTION: 'Your Subscription',
  YOU_CAN_CHANGE: 'You can change these settings at any time',
  YOU_DID_IT: 'You did it!',
  YOU_GOT_THIS: 'You got this!',
};
export default en;
